import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getJobInfo } from "../../../api/finance/addChargesApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationCrosshairs } from "@fortawesome/free-solid-svg-icons";

const StationaryMarker = ({
  terminalId,
  speed,
  vehNo,
  advDirSelected,
  showUnauthorizedStops = true,
}) => {
  const [isUnauthorizedStop, setIsUnAuthorizedStop] = useState(false);
  const jobData = useSelector(
    (state) => state.missionControl.jobInfo[terminalId],
  );

  useEffect(() => {
    if (speed === 0 && showUnauthorizedStops) {
      setTimeout(async () => {
        const jobDetails = await getJobInfo(jobData?.jobId);
        if (jobDetails && jobDetails.length > 0) {
          if (
            jobDetails[0].statusId === 8 ||
            jobDetails[0].statusId === 14 ||
            jobDetails[0].statusId === 20
          ) {
            setIsUnAuthorizedStop(true);
          }
        }
      }, 60000);
    }
  }, [jobData?.jobId, showUnauthorizedStops, speed]);
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "relative",
        }}
      >
        {isUnauthorizedStop ? (
          <FontAwesomeIcon
            style={{ color: "red", fontSize: "24px" }}
            beat
            icon={faLocationCrosshairs}
          />
        ) : (
          <FontAwesomeIcon
            style={{ color: "#3498db", fontSize: "24px" }}
            icon={faLocationCrosshairs}
          />
        )}
        <div
          style={{
            position: "absolute",
            top: "-30px",
            left: "0",
            translate: "-40% 0",
            padding: "5px",
            backgroundColor: "rgba(255, 255, 255, 1)",
            textAlign: "center",
            width: "80px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          {vehNo}
        </div>
      </div>
    </div>
  );
};

export default StationaryMarker;
